export default {
      id: "ic_recherche-usage",
      viewBox: "0 0 50 50",
      url: "../dist/images/" + "sprite.svg#ic_recherche-usage",
      toString: function () {
        return this.url;
      }
    }